import { render, staticRenderFns } from "./ReportOrderCount.vue?vue&type=template&id=e40632fe"
import script from "./ReportOrderCount.vue?vue&type=script&lang=js"
export * from "./ReportOrderCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports